import { render, staticRenderFns } from "./publish.vue?vue&type=template&id=251183ae&scoped=true"
import script from "./publish.vue?vue&type=script&lang=ts"
export * from "./publish.vue?vue&type=script&lang=ts"
import style0 from "./publish.vue?vue&type=style&index=0&id=251183ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251183ae",
  null
  
)

export default component.exports